export default __webpack_public_path__ + "static/data-driven-8370a61403e902c505d0c362eb0f1ce7.png";